// extracted by mini-css-extract-plugin
export default {"container":"KlashaSelect_container__g12x+","select":"KlashaSelect_select__i6oSJ"};